import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Air } from "@air/next-icons";
import Link from "next/link";
import { memo } from "react";
export const AppErrorBackground = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsxs("main", {
        className: "flex h-screen bg-cover bg-no-repeat",
        style: {
            backgroundImage: "url(/assets/illustrations/blue-blurred-background.svg)"
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "absolute inset-0 bg-cover bg-no-repeat",
                style: {
                    backgroundImage: "url(/assets/illustrations/air-blurred.svg)"
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "z-1 mx-auto flex h-[calc(100vh-52px)] max-w-[500px] flex-1 flex-col items-center justify-center gap-4 p-8 text-center",
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        href: "https://air.inc",
                        children: /*#__PURE__*/ _jsx(Air, {
                            className: "absolute left-8 top-10 w-[65px] text-blue-8"
                        })
                    }),
                    children
                ]
            })
        ]
    });
});
AppErrorBackground.displayName = "AppErrorBackground";
